"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KonfektionierungList = void 0;
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const Konfektionierung_1 = require("./Konfektionierung");
/**
 * The `KonfektionierungList` manages a list of `Konfektionierung` articles.
 */
class KonfektionierungList extends ArticleList_1.ArticleList {
    constructor() {
        super();
    }
    static fromScratch() {
        return new KonfektionierungList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new KonfektionierungList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new KonfektionierungList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new KonfektionierungList();
        list.fromArray(arr);
        return list;
    }
    static fromExistingArtNr(json, cloneStrategy = 'deep') {
        const list = new KonfektionierungList();
        list.fromExistingArtNr(json, cloneStrategy);
        return list;
    }
    static fromInventedArtNr(json, cloneStrategy = 'deep') {
        const list = new KonfektionierungList();
        list.fromInventedArtNr(json, cloneStrategy);
        return list;
    }
    fromJson(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(Konfektionierung_1.Konfektionierung.fromJson(itemJson, cloneStrategy));
        }
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        this.items = model.map((m) => Konfektionierung_1.Konfektionierung.fromModel(m));
        this.model = model;
        this.emitChange();
    }
    fromExistingArtNr(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(Konfektionierung_1.Konfektionierung.fromExistingArtNr(itemJson, cloneStrategy));
        }
        this.emitChange();
    }
    fromInventedArtNr(json, cloneStrategy = 'deep') {
        this.items = [];
        for (const itemJson of json) {
            this.items.push(Konfektionierung_1.Konfektionierung.fromInventedArtNr(itemJson, cloneStrategy));
        }
        this.emitChange();
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    clone() {
        return KonfektionierungList.fromArray(this.items.map((i) => i.clone()));
    }
    getByTyp(typ) {
        return this.get(typ, 'typ');
    }
    clearCalculatedPrices() {
        this.items.forEach((item) => {
            item.calculatedPriceVK = undefined;
            item.calculatedPriceEK = undefined;
        });
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
}
exports.KonfektionierungList = KonfektionierungList;
//# sourceMappingURL=KonfektionierungList.js.map